import React, { useEffect, useRef, useState, createRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  SActionBtn,
  SLowcodeList,
  SDrawer,
  SIDRender,
  STableActions,
} from 'shj-components'
import config from './config';
import { Button, Modal, Table, message, QRCode } from 'antd'
import dayjs from 'dayjs'
import {
  getTenantId,
} from '@/common/utils'
import { AddOrEditForm } from './components'
import { OnWriteOff } from './components/onWriteOff'
import { CollectionForm } from './components/collection'
import { PaymentPlanFn } from './components/paymentPlan'
import { verifyApplyFn } from './components/verifyApply'
import { receiptApplyPageList, receiptApply, receiptApplySubmit,
   findCanPaymentApplyResponseForHandle, paymentApplyForHandle,
   paymentApplyAddAndVerfiyBatch, httpDictServTenant, findQuotationTypes, 
   getEnum, handlerNoEffectiveData, receiptApplyDeleteApply } from '@/services/fmsServices'
export default function PaymentServiceManage(props) {
  const history = useNavigate();
  const { id, orderId, dealMode, financialOrgCode } = props
  const tenantId = getTenantId()
  const [openModal, setModal] = useState(false);
  const [openCollectModal, setOpenCollectModal] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [editData, setEditData] = useState(null);
  const [recordData, setRecordData] = useState(null);
  const [collectData, setCollectData] = useState(null);
  const [collectList, setCollectList] = useState([]);
  const [transResponseList, setTransResponseList] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const [makeEffectiveLoading, setMakeEffectiveLoading] = useState(false); //生效按钮
  const [QRloading, setQRLoading] = useState(false);
  const [lineLoading, setLineLoading] = useState(false);
  const [openType, setOpenType] = useState(false);
  const [openReceiptsConfirm, setOpenReceiptsConfirm] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [total, setTotal] = useState(0);
  const listRef = useRef<any>();
  const childRef = createRef<any>()
  const collectRef = createRef<any>()
  useEffect(() => {
    reloadFn()
  }, [id])
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        query.orderAccountId = id
        if(query.notEqualVerifyState === 'noVerifyStateNotEffective'){
          delete query.notEqualVerifyState 
        }
        receiptApplyPageList(current, pageSize, query).then((res)=>{
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  // 右侧表格事件：
  const onAdd = () => {
    setEditData(null)
    setReadOnly(false)
    setModal(true)
  }
  // 查看
  const onInfo = (record) => {
    setEditData(record)
    setReadOnly(true)
    setModal(true)
  }
  const onEdit = (record) => {
    setEditData(record)
    setReadOnly(false)
    setModal(true)
  }
  const skipRule = () => {
    // history('/main/fms/paymentService/' + record?.id)
    PaymentPlanFn({
      fn: () => {
        reloadFn()
      },
      seePlan: (record)=>{
        history('/config/receiptRulesManagement/' + record.planMainId);
      },
      ...{orderId},
    })
  }
  // 收款方式
  const onMergeReceipts = (record: any) => {
    if(record?.selectedRows?.length){
      const selectedRowsList = record.selectedRows.map(item => ({
        ...item,
        receivableDate: dayjs(item.receivableDate).format('YYYY-MM-DD HH:mm:ss')
      }));
      setCollectList(selectedRowsList)
    }else{
      setCollectList([{...record, receivableDate: dayjs(record.receivableDate).format('YYYY-MM-DD HH:mm:ss')}] as any || [])
    }
    setOpenType(true)
    setRecordData(record)
    // let typeModal = Modal.info({
    //   title: '收款方式选择',
    //   icon: null,
    //   closable: true,
    //   content: (
    //     <div style={{ padding: '30px 0' }}>
    //       <Button loading={QRloading} onClick={()=>{onQRReceiptsConfirm(record, typeModal)}}>生成收款二维码</Button>
    //       <Button style={{ marginLeft: 20 }} onClick={()=>{typeModal.destroy();onReceiptsConfirm(record)}}>线下收款</Button>
    //     </div>
    //   ),
    //   footer: null,
    // });
  }
  // 收款确认
  const columns = [
    {
      title: '交易类型',
      dataIndex: 'transactionTypeName',
    },
    {
      title: '收款金额',
      dataIndex: 'amount',
    },
  ];
  const onReceiptsConfirm = (record) => {
    setLineLoading(true)
    const list = record?.selectedRows?.length ? record.selectedRows.map(m => m.id) : [record.id];
    findCanPaymentApplyResponseForHandle({
      orderAccountId: id,
      receiptApplyIdList: list
    }).then((res) => {
      setOpenType(false)
      setLineLoading(false)
      setTransResponseList(res.transResponseList)
      setOpenCollectModal(true),
      setCollectData(null)
    }).catch(err=>{
      setLineLoading(false)
    })
  }
  const onQRReceiptsConfirm = (record) => {
    setQRLoading(true)
    // 优化收款确认逻辑
    const list = record?.selectedRows?.length ? record.selectedRows.map(m => m.id) : [record.id];
    findCanPaymentApplyResponseForHandle({
      orderAccountId: id,
      receiptApplyIdList: list
    }).then((res) => {
      setOpenType(false)
      setQRLoading(false)
      const totals = res.transResponseList.reduce((total, item) => total + item.amount, 0);
      setTotal(totals)
      setTransResponseList(res.transResponseList)
      setOpenReceiptsConfirm(true)
      // const closeModal = Modal.info({
      //   title: '收款金额确认',
      //   closable: true,
      //   icon: null,
      //   content: (
      //     <div style={{ padding: '30px 0', textAlign: 'center' }}>
      //       <Table columns={columns} dataSource={res.transResponseList} size="small" pagination={false} />
      //       <div style={{ padding: '10px 0' }}>收款金额合计<span style={{ color: 'red' }}>{total}</span>元，是否继续收款？</div>
      //       <Button onClick={() => { closeModal.destroy() }}>否</Button>
      //       <Button type='primary' loading={paymentLoading} style={{ marginLeft: 20 }} onClick={()=>onPaymentApply(res.transResponseList, closeModal)}>是</Button>
      //     </div>
      //   ),
      //   footer: null,
      // });
    }).catch(err=>{
      setQRLoading(false)
    })
  }
  const onSubmit = () => {
    childRef.current?.validateFields().then(async (values: any) => {
      // 优化日期格式化和标志设置
      const formatDate = (date: any) => date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : undefined;
      values.receivableDate = formatDate(values.receivableDate);
      values.orderAccountId = id
      setLoadingSubmit(true)
      receiptApplySubmit(values, id).then((res:any)=>{
        message.success(res.message || '提交成功')
        reloadFn()
        setLoadingSubmit(false)
        setModal(false)
      }).catch(err=>{
        setLoadingSubmit(false)
      })
    })
  }
  const onPaymentApply = (updatedTransList: any) => {
    // 修改 transList 中的字段名
    const transList = updatedTransList.map(item => ({
      ...item,
      receiptApplyRequestList: item.receiptApplyResponseList
    }));
    setPaymentLoading(true)
    paymentApplyForHandle({
      orderAccountId: id,
      transList,
    }).then((res)=>{
      setPaymentLoading(false)
      setOpenReceiptsConfirm(false)
      let paymentOrderId = res?.paymentApply?.paymentOrderId
      reloadFn()
      showQRcode(paymentOrderId)
    }).catch(err=>{
      setPaymentLoading(false)
    })
  }
  const showQRcode = (paymentOrderId) =>{
    const currentDomain = window.location.origin;
    let copyLink = `${currentDomain}/h5/#/pages/payment/index?orderId=${paymentOrderId}&tenantId=${tenantId}`;
    Modal.info({
      title: '收款二维码已生成，请使用手机扫一扫完成支付！',
      closable: true,
      icon: null,
      content: (
        <div style={{ padding: '30px 0 15px 0', textAlign: 'center'}}>
          <div style={{display: 'flex', justifyContent: 'center', marginBottom: 15}}>
            <QRCode value={copyLink} />
          </div>
          <Button color="primary" variant="filled" onClick={() => {
            navigator.clipboard.writeText(copyLink).then(() => {
              message.success('复制成功');
            });
          }}>
            复制链接
          </Button>
        </div>
      ),
      footer: null,
    });
  }
  const onConfirmCollect = () => {
    collectRef.current?.validateFields().then(async (values: any) => {
      const formatDate = (date: any) => date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : undefined;
      values.receivedDate = formatDate(values.receivedDate);
      values.accountingDate = formatDate(values.accountingDate);
      // values.receivedClickDate = formatDate(values.receivedClickDate);
      values.customerReceiptFlag = values.customerReceiptFlag ? '1' : '0';
      values.creditFlag = values.creditFlag ? '1' : '0';
      values.orderAccountId = id
      let list: any = collectRef.current?.getValue()?.details;
      // 根据 receiptType 合并相同的项
      const mergedList = list.reduce((acc: any, item: any) => {
        const existing = acc.find((i: any) => i.receiptType === item.receiptType);
        if (existing) {
          existing.paymentApplyReceiptApplyList.push({
            needVerifiedAmount: item.needVerifiedAmount,
            receiptApplyId: item.id,
            receiptType: item.receiptType,
          }); // 合并相同 receiptType 的项
        } else {
          acc.push({ receiptType: item.receiptType, paymentApplyReceiptApplyList: [{
            needVerifiedAmount: item.needVerifiedAmount,
            receiptApplyId: item.id,
            receiptType: item.receiptType,
          }]});
        }
        return acc;
      }, []);
      const updatedMergedList = mergedList.map((item) => {
        // 新增 transactionType 参数
        const updatedPaymentApplyReceiptApplyList = item.paymentApplyReceiptApplyList.map(paymentItem => {
          // 匹配 transResponseList 中的 receiptApplyResponseList
          const matchingResponse = transResponseList.find(responseItem => 
            responseItem.receiptApplyResponseList.some(response => response.receiptApplyId === paymentItem.receiptApplyId)
          );
          return {
            ...paymentItem,
            transactionType: matchingResponse ? matchingResponse.transactionType : undefined, // 添加 transactionType
          };
        });
        return {
          ...values,
          receiptType: item.receiptType,
          transactionType: updatedPaymentApplyReceiptApplyList[0]?.transactionType, // 设置为第一个元素的 transactionType
          amount: updatedPaymentApplyReceiptApplyList.reduce((total, m) => total + ((m.needVerifiedAmount) || 0), 0),
          paymentApplyReceiptApplyList: updatedPaymentApplyReceiptApplyList
        };
      });
      // 输出新的数组
      if (collectRef.current?.getValue()?.isValid && collectRef.current?.getValue()?.errData === null) {
          setLoading(true)
          paymentApplyAddAndVerfiyBatch({list: updatedMergedList}).then((res)=>{
            message.success(res.message || '线下收款成功')
            reloadFn()
            setLoading(false)
            setOpenCollectModal(false)
          }).catch(err=>{
            setLoading(false)
          })
      } else {
        message.error('收款明细里面的收款金额未填写或有误');
      }
    })
  }
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  const onSave = () => {
    childRef.current?.validateFields().then(async (values: any) => {
      // 优化日期格式化和标志设置
      const formatDate = (date: any) => date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : undefined;
      values.receivableDate = formatDate(values.receivableDate);
      values.orderAccountId = id
      setLoading(true)
      receiptApply(values, id).then((res:any)=>{
        message.success(res.message || '保存成功')
        reloadFn()
        setLoading(false)
        setModal(false)
      }).catch(err=>{
        setLoading(false)
      })
    })
  }

  const onWriteOffModal = (record: any) => {
    record.sourceBillType = 'verifySourceTypeReceiptApply'
    record.orderAccountId = id
    OnWriteOff({
      fn: () => {
        reloadFn();
      },
      ...record,
    });
  };
  const verifyApplyModal = (record: any) => {
    record.sourceBillType = 'verifySourceTypeReceiptApply'
    verifyApplyFn({
      fn: () => {
        reloadFn();
      },
      ...record,
    });
  };
  const onQRCode = (record: any) => {
    // 在这里添加生成二维码的逻辑
    showQRcode(record.paymentOrderId)
  }
  const onDelete = (record: any) => {
    receiptApplyDeleteApply({
      receiptApplyId: record.id
    }).then((res: any) => {
      message.success(res.message || '删除成功')
      reloadFn()
    }).catch(err => {
      message.error(err.message || '删除失败')
    })
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      let receiptTypeList = await httpDictServTenant({ parentKey: 'receiptType',enabled: 1 })
      let contractTypeList = await findQuotationTypes()
      const verifyStateList: any = await getEnum('com.shj.saas.plus.fms.enums.VerifyStateEnum')
      const payStateList: any = await getEnum('com.shj.saas.plus.fms.enums.RceiptApplyPayStateEnum')
      resolve({
        notEqualVerifyStateList: [{
          lable: '不显示',
          value: 'verifyStateNotEffective'
        },{
          lable: '显示',
          value: 'noVerifyStateNotEffective'
        }],
        receiptTypeList,
        contractTypeList,
        verifyStateList,
        payStateList
      },)
    })
  }
  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, skipRule, onMergeReceipts },
    getCheckboxProps: (item)=>({
      disabled: !(item.unverifiedAmount > 0  &&  (item.payState === 'rceiptApplyNotPay' || item.payState === 'rceiptApplyPartPaid'))
    }),
    status: {
      onMergeReceiptsDisabled: ({selectedRowKeys}: Record<string, number[]>) => selectedRowKeys.length <= 1,
      skipRuleDisabled: () => dealMode === 'DIRECT',
    },
    customRender: {
      clueIdRender(text: any, record: any) {
        return (
          <SIDRender id={text} onClick={() => onInfo(record)} copy={false}></SIDRender>
        )
      },
      renderOperate(_, record: Record<string, any>) {
        let hasDis = false
        if(record?.receiptApplyFlows){
          hasDis = record.receiptApplyFlows.some(item=>item.processState === 'waitAudit')
        }
        console.log(hasDis)

        return (
          <STableActions>
            {
              record.unverifiedAmount > 0  &&  (record.payState === 'rceiptApplyNotPay' || record.payState === 'rceiptApplyPartPaid') ? <SActionBtn auth="ReceivableListReceipts" disabled={hasDis} tipText={hasDis?`该应收单已有进行中的${record?.verifyState==='verifyStateCreate'?'新增':'删除'}审批流，请审批完成后进行操作！`:''} onClick={() => onMergeReceipts(record)}>收款</SActionBtn>:null

            }
            {
              record.unverifiedAmount != 0 && record.payState !== 'rceiptApplyPaying' ? <SActionBtn auth="ReceivableListWriteOffModal" disabled={hasDis} tipText={hasDis?`该应收单已有进行中的${record?.verifyState==='verifyStateCreate'?'新增':'删除'}审批流，请审批完成后进行操作！`:''} onClick={() => onWriteOffModal(record)}>核销</SActionBtn>:null

            }
            {
              record.verifiedAmount != 0 ? <SActionBtn auth="ReceivableListVerifyApplyModal" onClick={() => verifyApplyModal(record)}>核销查询</SActionBtn>:null
            }
            {
              record.payState === 'rceiptApplyPaying' ? <SActionBtn auth="ReceivableListQRCode" onClick={() => onQRCode(record)}>收款二维码</SActionBtn>:null
            }
            {
              record.verifyState === 'verifyStateCreate' ?  <SActionBtn auth="ReceivableListEdit" onClick={() => onEdit(record)}>提交</SActionBtn>: null
            }
            {
              record.verifyState === 'verifyStateCreate' || record.verifyState === 'verifyStateNoVerify' ?  <SActionBtn auth="ReceivableListDelete" danger onClick={()=>onDelete(record)}>删除</SActionBtn>: null
            }
            {
              record.verifyState === 'verifyStateNotEffective' ? (
                <SActionBtn 
                  auth="ReceivableListMakeEffective" 
                  loading={makeEffectiveLoading} 
                  onClick={() => {
                    setMakeEffectiveLoading(true);
                    handlerNoEffectiveData({ receiptApplyId: record.id })
                      .then(() => {
                        message.success('生效成功');
                        reloadFn();
                      })
                      .finally(() => setMakeEffectiveLoading(false));
                  }}
                >
                  生效
                </SActionBtn>
              ) : null
            }
            <SActionBtn></SActionBtn>
          </STableActions>
        )
      },
    },
  }
  return (
    <div>
      <SLowcodeList config={config} tableType="antd" ref={listRef} {...extension} 
        searchMode="group"
        summary={() => {
          const dataSource = listRef.current?.getDataSource() || [];
          if (dataSource.length === 0) {
            return null; // 没有数据时不显示 Table.Summary
          }
          const totalAmounts = dataSource.reduce(
            (totals, record) => {
              totals.receivable += record.receivableAmount || 0;
              totals.verified += record.verifiedAmount || 0;
              totals.unverified += record.unverifiedAmount || 0;
              return totals;
            },
            { receivable: 0, verified: 0, unverified: 0 }
          );
          const formatAmount = (amount) => Number(amount).toFixed(2);
          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                <Table.Summary.Cell index={1}></Table.Summary.Cell>
                <Table.Summary.Cell index={2}>合计</Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  {formatAmount(totalAmounts.receivable)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4}>
                  {formatAmount(totalAmounts.verified)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5}>
                  {formatAmount(totalAmounts.unverified)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
       />
      {/* 新增弹出抽层 */}
      <SDrawer
        title={readOnly ? '查看应收' : '新增应收'}
        width="50%"
        isHideResetBtn={false}
        footer={!readOnly ? [
          <Button onClick={onSave} loading={loading} disabled={loadingSubmit}>保存</Button>,
          <Button type='primary' style={{ marginLeft: 10 }} loading={loadingSubmit} onClick={onSubmit} disabled={loading}>直接提交</Button>
        ] : []}
        open={openModal}
        onClose={() => setModal(false)}
        destroyOnClose
        styles={{ header: { padding: '8px 15px' } }}
      >
        <AddOrEditForm ref={childRef} editData={editData} orderId={orderId} readOnly={readOnly} />
      </SDrawer>
      {/* 线下收款 */}
      <SDrawer
        title={'线下收款'}
        width="50%"
        okText="确认收款"
        isHideResetBtn={false}
        open={openCollectModal}
        onClose={() => setOpenCollectModal(false)}
        destroyOnClose
        loading={loading}
        onSubmit={onConfirmCollect}
        styles={{ header: { padding: '8px 15px' } }}
      >
        <CollectionForm ref={collectRef} collectData={collectData} collectList={collectList} financialOrgCode={financialOrgCode} />
      </SDrawer>
      <Modal
        title="收款方式选择"
        open={openType}
        footer={null}
        closable={true}
        onCancel={() => {setOpenType(false)}}
      >
         <div style={{ padding: '30px 0' }}>
          {/* 线上支付还没有好 */}
          {/* <Button loading={QRloading} onClick={()=>{onQRReceiptsConfirm(recordData)}}>生成收款二维码</Button> */}
          <Button loading={lineLoading} style={{ marginLeft: 20 }} onClick={()=>{onReceiptsConfirm(recordData)}}>线下收款</Button>
        </div>
      </Modal>
      <Modal
        title="收款金额确认"
        open={openReceiptsConfirm}
        footer={null}
        closable={true}
        onCancel={() => {setOpenReceiptsConfirm(false)}}
      >
          <div style={{ padding: '30px 0', textAlign: 'center' }}>
            <Table columns={columns} dataSource={transResponseList} size="small" pagination={false} />
            <div style={{ padding: '10px 0' }}>收款金额合计<span style={{ color: 'red' }}>{total}</span>元，是否继续收款？</div>
            <Button onClick={() => {setOpenReceiptsConfirm(false)}}>否</Button>
            <Button type='primary' loading={paymentLoading} style={{ marginLeft: 20 }} onClick={()=>onPaymentApply(transResponseList)}>是</Button>
          </div>
      </Modal>
    </div>
  )
}
